var $luxeProductHandle = 'luxe-gift-wrap';
var $luxeVariantID = $('.gift-options').data('luxe-variant-id');
var $checkoutButton = $('button[name="checkout"]');
var $selectedGiftWrap = '';

function disableCheckoutButton(){
  $checkoutButton.prop('disabled', false).removeClass('disabled').removeAttr('disabled');
}

var is_checking_selected = false;
function setSelectedGiftWrap(){
  if(is_checking_selected == true){ return; }
  is_checking_selected = true;
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      var productIsInCart = false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].handle === $luxeProductHandle) {
          productIsInCart = true; break;
        }
      }

      if(cart.items.length == 1 && productIsInCart){
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {id: $luxeVariantID,quantity: 0},
          dataType: 'json',
          success: function(cart) {
            disableCheckoutButton();
            is_checking_selected = false;
            window.location.reload();
          },
          error: function(error) {
            is_checking_selected = false;
            disableCheckoutButton();
          }
        }); 
        return;
      }

      $('.wrapping-option').removeClass('active');
      if (productIsInCart) {
        $('.gift-wrap-selection[value="Luxe Gift Wrapping"]').prop('checked',true);
        $('.wrapping-option.luxe').addClass('active');
      } else {
        $('.gift-wrap-selection[value="Environmentally Friendly"]').prop('checked',true);
        $('.wrapping-option.eco').addClass('active');
      }

      $selectedGiftWrap = $('.gift-wrap-selection:checked').val();
      $('.attribute-packing').each(function(){
        $(this).val( $selectedGiftWrap );
      });

      is_checking_selected = false;
      disableCheckoutButton();
    },
    error: function(error) {
      is_checking_selected = false;
      disableCheckoutButton();
    }
  });
} 

  function updateLuxeWrapInCart($elem){
    $checkoutButton.prop('disabled', true).addClass('disabled'); 
    
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        var productInCart = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].handle === $luxeProductHandle) {
            productInCart = true;
            break;
          }
        }
        if($elem == 'form'){
          $selectedGiftWrap = cart.attributes.Packaging;
          if($selectedGiftWrap == '' || $selectedGiftWrap == undefined || $selectedGiftWrap == null ){
            $selectedGiftWrap = 'Environmentally Friendly';
          }
        } else {
          $selectedGiftWrap = $elem.val();
        }
        
        $('.attribute-packing').each(function(){
          $(this).val( $selectedGiftWrap );
        });       

        //set selected value for both cart and minicart
        $('.wrapping-option').removeClass('active');
        $('input[value="'+ $selectedGiftWrap +'"]').each(function(){
          $(this).prop('checked',true);
          $(this).parent().parent().addClass('active');
        });

        if (productInCart) {
          if($selectedGiftWrap == 'Environmentally Friendly'){
            $('#CartDrawer,.page-cart').addClass('loading');
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {id: $luxeVariantID,quantity: 0},
              dataType: 'json',
              success: function(cart) {
                //disableCheckoutButton();
                var attributes = {attributes: {Packaging: $selectedGiftWrap}};
                updateAttributes(attributes);
              },
              error: function(error) {
                disableCheckoutButton();
              }
            });            
          }
        } else {
          if($selectedGiftWrap == 'Luxe Gift Wrapping'){
            $('#CartDrawer,.page-cart').addClass('loading');
            var properties = { 'Gift Wrap': 'Yes' };
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: {id: $luxeVariantID,quantity: 1},
              success: function(response) {
                //disableCheckoutButton();
                var attributes = {attributes: {Packaging: $selectedGiftWrap}};
                updateAttributes(attributes);
              },
              error: function(error) {
                disableCheckoutButton();
              }
            });
          }
        }
      },
      error: function(error) {
        disableCheckoutButton();
      }
    });
  }

  function updateAttributes($attributes){
    console.log('called')
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: $attributes,
        dataType: 'json',
        success: function(cart) {
          //reload cart
          disableCheckoutButton();
          $('cart-drawer').load(location.href + " #CartDrawer",function(){ $('#CartDrawer,.page-cart').removeClass('loading');});
          $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
        },
        error: function(error) {
          disableCheckoutButton();
        }
      });
  }

function priceRangeFilter(){
  initiatePriceSlider("#price-range-filter",'price-min-input','price-max-input','#FacetFiltersForm');
  initiatePriceSlider("#price-range-filter-mobile",'price-min-input-mobile','price-max-input-mobile','#FacetFiltersFormMobile');
}

function initiatePriceSlider(slider_id,min_ip_class,max_ip_class,form_id){
  $(slider_id).slider({tooltip:'hide',});
  $(slider_id).on("slide", function(slideEvt) {
    const min_input = document.getElementsByClassName(min_ip_class);
    const max_input = document.getElementsByClassName(max_ip_class);
    const facetFilterForm = document.querySelector(form_id);

    var current_min = min_input[0].value;
    var current_max = max_input[0].value;

    var new_min = slideEvt.value[0];
    var new_max = slideEvt.value[1];
    if(current_min != new_min){
      min_input[0].value = slideEvt.value[0];
      //$('.price-min-val').text('$'+slideEvt.value[0]);
      facetFilterForm.dispatchEvent(new Event('input'));
    }

    if(current_max != new_max){
      max_input[0].value = slideEvt.value[1];
     //$('.price-max-val').text('$'+slideEvt.value[1]);
      facetFilterForm.dispatchEvent(new Event('input'));
    }
  });
}

var $grid_masonary = null;
var _grid_masonary = null;

jQuery(function(){

  function detectOSandBrowser(){
    // Browser detection
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isFirefox = /Firefox/.test(navigator.userAgent);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    var isOpera = /OPR/.test(navigator.userAgent);
    var isIE = /Trident/.test(navigator.userAgent);

    // OS detection
    var isWindows = /Windows/.test(navigator.userAgent);
    var isMac = /Macintosh/.test(navigator.userAgent);
    var isLinux = /Linux/.test(navigator.userAgent);

    // Add classes to body tag
    if (isChrome) {
        $('body').addClass('on-chrome');
    } else if (isFirefox) {
        $('body').addClass('on-firefox');
    } else if (isSafari) {
        $('body').addClass('on-safari');
    } else if (isOpera) {
        $('body').addClass('on-opera');
    } else if (isIE) {
        $('body').addClass('on-ie');
    }

    if (isWindows) {
        $('body').addClass('on-windows');
    } else if (isMac) {
        $('body').addClass('on-mac');
    } else if (isLinux) {
        $('body').addClass('on-linux');
    }
  }
  detectOSandBrowser();

    var $announcementBanner = $('.utility-bar')
    if($announcementBanner.length){
      if (!getCookie('announcement_hidden')) {
        $announcementBanner.slideDown('fast');
      } else {
        $('body').addClass('announcement-hidden')
      }
      $('.close-announcement').click(function(){
        setCookie('announcement_hidden','yes');
        $announcementBanner.slideUp('fast');
        return false;
      });
    }

    var $cookieBanner = $('#CookieBanner')
    if($cookieBanner.length){
      if (!getCookie('cookieAccepted')) {
        $cookieBanner.fadeIn('slow');
      } else {
        $('body').addClass('cookie-accepted')
      }
      $('.accept-cookies').click(function(){
        setCookie('cookieAccepted','yes');
        $cookieBanner.fadeOut('slow');
        return false;
      });
    }

    function setCookie(name,value) {
        var end = new Date();
        var temp = end.getTime() + 86400000;
        end.setTime(temp);
        document.cookie = name+'='+ value +'; expires=' + end.toGMTString() ;
    }
    function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

  $('.open-image-nav').click(function(){
    var $target = $(this).data('for');
    $('.mega-sub-image-nav:not('+ $target +')').hide()
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $($target).stop(true).fadeOut('fast');
    } else {
      $('.open-image-nav').removeClass('active');
      $(this).addClass('active');
      $($target).stop(true).fadeIn('fast');
    }
    
    return false;
  });

  $('.close-mega-menu').click(function(){
    $(this).parent().parent().removeAttr('open');
    $('body').removeClass('mega-menu-active');
  });
  
  $('summary.list-menu__item').click(function(){

    if($(window).width() > 989){
      if($('body').hasClass('mega-menu-active')){
        $('body').removeClass('mega-menu-active');
      } else {
        $('body').addClass('mega-menu-active');
      }
    } else {
      $('body').removeClass('mega-menu-active');
    }
    
    if($(this).hasClass('active-menu')){
      $(this).removeClass('active-menu');
    } else {
      $('summary.list-menu__item').removeClass('active-menu');
      $(this).addClass('active-menu');
    }
  });
  /* $(".list-menu__item").mouseenter(function() {
    $('body').addClass('mega-menu-active');
    $(this).parent().attr('open','');
  });

  $('.header-wrapper').mouseleave(function() {
    $('body').removeClass('mega-menu-active');
    $(this).parent().removeAttr('open');
  }); */

  $('.footer-block__newsletter .footer-block__heading').click(function(){
    $(this).parent().find('.footer-block__newsletter-details').stop(true).slideToggle('fast');
  });

  $('.filter-sort-button,.apply-filters-button,.close-desktop-filter').click(function(){
    if($(window).width() > 749){
      $('#main-collection-filters').stop(true).slideToggle();
    } else {
      $('#main-collection-filters').stop(true).show();
      $('menu-drawer > details').addClass('menu-opening').attr('open','');
      
    }
    return false;
  });

  $(document).on("click",'a[href="#add_all_to_cart"]',function() {
    var btn = $(this);
    var $variant_ids = btn.parent().find('.bulk_atc_product').data('variant-ids');
    if($variant_ids.length && $variant_ids != undefined && $variant_ids != null){
      $variant_ids = $variant_ids.split(',');
      var add_variants = [];
      $.each($variant_ids,function(i){
        add_variants.push({ id: $variant_ids[i], quantity: 1 });
      });
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        dataType:'json',
        data: { items: add_variants },
        beforeSend: function() {
          $('body').addClass('lock-screen');
        },
        success: function(data) {
          if( data.message && data.message!=undefined && data.message!='' ){
            btn.parent().find('.atc-error').html(data.description).show();
            btn.parent().find('.atc-success').hide();
          } else {
            //reloadMiniCart();
            btn.parent().find('.atc-success').show();
            btn.parent().find('.atc-error').hide();

            //reloadCart();
            $('cart-drawer').load(location.href + " #CartDrawer");
            $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
            $('cart-drawer').removeClass('is-empty');
            
            setTimeout(function(){
              //window.location.reload();
            },2000);
            
          }
          $('body').removeClass('lock-screen');
        },
        error: function(xhr) { // if error occured

          if(xhr.responseJSON && xhr.responseJSON.message && xhr.responseJSON.description){
            btn.parent().find('.atc-error').html('Unable to add all products to cart. '+xhr.responseJSON.description).show();
          } else {
            btn.parent().find('.atc-error').html('Unable to process your request! Please try again!').show();
          }
          $('body').removeClass('lock-screen');
      }
      });
    }
    return false;    
  });

  function reloadCart() {
    //if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    /* } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }*/
  }

  function reloadMiniCart() {
    $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: 'html',
        success: function(data) {
            // Update the mini cart contents with the reloaded data
            $('.drawer__cart-items-wrapper').html($(data).find('.drawer__cart-items-wrapper').html());
        },
        error: function(xhr, status, error) {
            console.error('Error reloading mini cart: ' + error);
        }
    });
}

  $(document).on("click",'.open-order-details',function(e) {
    e.preventDefault();
    var $link = $(this).attr('href');
    $.ajax({
        type: 'GET',
        url: $link,
        dataType: 'html',
        success: function(data) {
           $('.order-details-popup-inner').html($(data).find('.order-details-wrapper').html());
           $('.order-details-popup').fadeIn('fast');
          
        },
        error: function(xhr, status, error) {
            console.error('Error reloading mini cart: ' + error);
        }
    });
    
    return false;
  });

  $('.close-order-details').click(function(){
    $('.order-details-popup').fadeOut('fast');
  });

  $(document).on("click",".accordion-title",function() {
    if($(this).hasClass('open')){
      $(this).removeClass('open');
      $(this).next().stop('true').slideUp('fast');
    } else {
      $(this).addClass('open');
      $(this).next().stop('true').slideDown('fast');
    }
  });

  $(document).on("click",".navigation-grid h4",function() {
    if($(window).width() < 575){
      if($(this).hasClass('open')){
        $(this).removeClass('open');
        $(this).next().stop('true').slideUp('fast');
      } else {
        $(this).addClass('open');
        $(this).next().stop('true').slideDown('fast');
      }
    }
  });
  

  $(document).on("click",".custom-slide-dot",function(e) {
    return false;
  });

  if($("[data-fancybox]").length){
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      Images: {
        initialSize: "cover",
        /*Panzoom: {
          panMode: "mousemove",
          mouseMoveFactor: 1.1,
          mouseMoveFriction: 0.12
        },*/
      },
      Toolbar: {
        display: {
          right: ['zoom', 'fullscreen', 'close'],
        }
      },
      Thumbs: false,Hash: false,
      on: {
        done: (fancybox, slide) => {
          //$('.fancybox-image').trigger('click');
        },
        loaded: (fancybox, slide) => {
          //$('.fancybox-image').trigger('click');
        },
      }
    });
    $(document).on("click",".fancybox-image",function(e) {
      
    });
  }


  var scrollTimeout;
  $('.product__media-list').on('scroll', function() {
    clearTimeout(scrollTimeout);

    var scrollPosition = $(this).scrollLeft();
    var containerWidth = $(this).width();
    var totalWidth = $(this)[0].scrollWidth;
    var scrollFraction = scrollPosition / (totalWidth - containerWidth);
    var numberOfItems = $(this).children('.product__media-item').length;
    var currentIndex = Math.round(scrollFraction * (numberOfItems - 1));
    currentIndex = currentIndex+1;
    
    scrollTimeout = setTimeout(function() {
      $('.mobile-gallery-dots').find('li button').removeAttr('aria-current');
      $('.mobile-gallery-dots').find('li[data-media-position="'+currentIndex +'"] button').attr('aria-current',true)
    }, 100);
  });

  var ppzr = $('.product-personalizer');
  _monogram_notice();
  function _monogram_notice(){
    if(ppzr.length){
      $('#btn-add-remove-monogram,.monogram-notice').show();
    } else {
      setTimeout(function(){
        _monogram_notice();
      });
    }
  }

  $('#btn-add-remove-monogram').click(function(){
   
    var $btn = $(this);
    if($btn.hasClass('monogram-open')){
      clearMonogram()
    } else {
      ppzr.addClass('open');
      $btn.addClass('monogram-open');
      appendExtras();
      setTimeout(function(){
        appendExtras();
      },100);
      setTimeout(function(){
        appendExtras();
      },2000);
      
    }
  });

  function clearMonogram(){
    $('.pplr-wrapper input[type=text], .pplr-wrapper textarea').val('').trigger('change');
    var pplr_wrappers = document.getElementsByClassName("pplr-wrapper");
    for (var i = 0; i < pplr_wrappers.length; i++) {
        var pplr_inputs = pplr_wrappers[i].querySelectorAll('input[type="text"], textarea');
        pplr_inputs.forEach(function(input) {
          input.dispatchEvent(new Event('input'));
        });
    }
    ppzr.removeClass('open');
    $('.pplr_preview_wrapper').remove();
    $('.product__media').removeClass('pplr')
    $('#btn-add-remove-monogram').removeClass('monogram-open');
  }

  function appendExtras(){
    if(ppzr.find('.close_monogram_tool').length == 0){
      ppzr.prepend('<a href="#close_monogram_tool" class="close_monogram_tool">&nbsp;</a>');
    }
    if(ppzr.find('.personalization_notice').length == 0 && $('.monogram_service_notice_on_tool').length > 0){
      ppzr.append('<div class="personalization_notice color-primary">'+ $('.monogram_service_notice_on_tool').html() +'</a>')
    }
  }

  $(document).on("click",".close_monogram_tool",function() {
    clearMonogram();
    return false;
  });


  var sgw = $('.size-guide-wrap');
  if(sgw.length>0){
    $('body').append('<div class="size-guide-popup" style="display:none"><div>'+
                     '<a href="#close" class="close-guide-popup"><span class="text-back">BACK</span><img src="//www.markcross.com/cdn/shop/t/66/assets/icon-close-x.svg?v=133976537625014200131747746487" alt="X" /></a><div>'+
                     '<div class="size-guide-popup-content"></div></div></div><div>');

    //$('.size-guide-popup-content').html( $('.size-guide-guide-content').html() )
    //$('.size-guide-popup').fadeIn('fast')
    
    $(document).on("click",".btn-size-guide",function(e) {
      e.preventDefault();
      $class = $('.size-guide-guide-content').data('guide-type')+'-size-guide'
      $('.size-guide-popup-content').html( $('.size-guide-guide-content').html() )
      $('.size-guide-popup').addClass($class).fadeIn('fast',function(){
        $(".size-guide-popup > div > div").mCustomScrollbar({ alwaysShowScrollbar:1 });
      })
    });
    $(document).on("click",".close-guide-popup",function(e) {
      e.preventDefault();
      $('.size-guide-popup').stop(true).fadeOut('fast',function(){
        $('.size-guide-popup-content').html( '' )
        $(".size-guide-popup > div > div").mCustomScrollbar("destroy");
      })
    });
  }

  /* $('.header__icon--cart').hover(function(){
    $('cart-drawer').addClass('active');
  }); */

  var $ss = $(".slick-slideshow");
  if($ss.length){
    $ss.each(function(){
      var $sslide = $(this);
      var $desk_slides = $sslide.data('desktop-slides');
      var $mob_slides = $sslide.data('mobile-slides');
      var $desk_scroll = $sslide.data('desktop-slides-to-scroll');
      var $mob_scroll = $sslide.data('mobile-slides-to-scroll');
      var $auto_rotate = $sslide.data('auto_rotate');
      var $slide_speed = $sslide.data('slide-speed');

      var $desk_arrows = $sslide.data('desktop-arrows');
      var $mob_arrows = $sslide.data('mobile-arrows');
      
      $sslide.slick({
        infinite: true,
		slidesToShow: $desk_slides,
        slidesToScroll: $desk_scroll,
        dots: true,
        arrows: $desk_arrows,
        adaptiveHeight: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            slidesToShow: $mob_slides,
            slidesToScroll: $mob_scroll,
            arrows: $mob_arrows
          }
        }]
      });
    });
  }

  if($(".split-products.slider").length){

    $(".split-products.slider").each(function(){
      var $sslide = $(this);
      var $mob_slides = $sslide.data('mobile-slides');
      $(".split-products.slider").slick({
        infinite: true,
        slidesToShow: 1,
        responsive: [{
          breakpoint: 750,
          settings: {
            slidesToShow: $mob_slides,
            infinite: true
          }
        }]
      });
    });   
    
  }
  if($(".split-products.carousel").length){
    $(".split-products.carousel").slick({
      infinite: true,
      slidesToShow: 3
    });
  }
  if($(".split-image-slider").length){
    $(".split-image-slider").slick({
      infinite: true,
      adaptiveHeight: true,
      autoplay: false,
      dots: true,
      responsive: [{
        breakpoint: 750,
        settings: {
          arrows: false
        }
      }]
    });
  }
  let $mc_carousels = $('.multicolumn-wrap.with-carousel > div');
  if($mc_carousels.length){
    $mc_carousels.each(function(){
      var $mc_carousel = $(this);
      $mc_carousel.slick({
        infinite: true,
        slidesToShow: $mc_carousel.data('cols-desktop'),
        responsive: [{
          breakpoint: 750,
          settings: {
            slidesToShow: $mc_carousel.data('cols-mobile'),
            infinite: true,
            initialSlide:$mc_carousel.data('mobile-peek')==true || $mc_carousel.data('mobile-peek')=='true'?1:0,
            arrows: false
          }
        }]
      });
    });
  }


  if($('body').hasClass('template-collection') || $('body').hasClass('template-search'))
    priceRangeFilter();

  if($('.grid-masonary').length){
    var masonary_initiated = false;
    var mobile_gutter_set = false;
    var desktop_gutter_set = false;
    var tablet_gutter_set = false;

    function getGutterSize() {
        var windowWidth = $(window).width();
        var gutter = 10;
        if (windowWidth >= 990) {
          gutter = 20;
          desktop_gutter_set = true;
          mobile_gutter_set = false;
          tablet_gutter_set = false;
        } else if (windowWidth >= 750) {
          gutter = 14;
          tablet_gutter_set = true;
          mobile_gutter_set = false;
          desktop_gutter_set = false;
        } else {
          mobile_gutter_set = true;
          desktop_gutter_set = false;
          tablet_gutter_set = false;
        }
        return gutter;
    }

    _grid_masonary = function(){
      $grid_masonary = $('.grid-masonary').isotope({
        itemSelector: '.grid__item',
        percentPosition: true,
        masonry: {
          columnWidth: '.ref-grid-item',
          gutter: getGutterSize()
          //horizontalOrder: true
        }
      });
      responsiveUpdates();
      $("#price-range-filter").slider({tooltip:'hide',});
      masonary_initiated = true;
    }
    
    _grid_masonary();
   
    var $_loading_page = '';
    var next_page = 'empty';
    var next_loading = false;
    function ScrollExecute() {
      var windowHeight = $(window).height();
      var scrollPosition = $(window).scrollTop();
      var gridBottom = $('.grid-masonary').offset().top + $('.grid-masonary').outerHeight();
       if( (windowHeight + scrollPosition) >= gridBottom && next_loading == false && $('.infinite_next a').length && $_loading_page != next_page ) {   
         next_loading = true;
           $('.load-indicator').addClass('loading');
           var next_page = $('.infinite_next a').attr('href');
           $_loading_page = next_page;
           $.ajax({
                type: 'GET',
                url: next_page,
                success: function(data) {
                  var filteredData = $(data).find(".grid-masonary").html();
                  if(filteredData){
                    filteredData = $(filteredData);
                    $grid_masonary.append( filteredData ).isotope( 'appended', filteredData );
                    responsiveUpdates();
                  }

                  var next_new_page = $(data).find(".infinite_next a");
                  if(next_new_page.length){
                    $('.infinite_next a').attr('href',next_new_page.attr('href'));
                  } else {
                    $('.infinite_next').remove();
                  }
                  
                  $_loading_page = '';
                  next_loading = false;
                  $('.load-indicator').removeClass('loading');
                },
                dataType: "html"
            });
           
       }
     }
    
     $(window).scroll(function(){
       setTimeout(function(){ ScrollExecute(); },200);
     });
  }

  if($('.order-history').length){

    var $_order_loading_page = '';
    var order_next_page = 'empty';
    var order_next_loading = false;
    function loadMoreOrders() {
         order_next_loading = true;
         $('.load-indicator').addClass('loading');
         $('.load-more-wrap').hide();
         var order_next_page = $('.infinite_next a').attr('href');
         $_order_loading_page = order_next_page;
         $.ajax({
              type: 'GET',
              url: order_next_page,
              success: function(data) {
                var filteredData = $(data).find(".order-history tbody").html();
                if(filteredData){
                  filteredData = $(filteredData);
                  $('.order-history').find('tbody').append( filteredData );
                  responsiveUpdates();
                }

                var next_new_page = $(data).find(".infinite_next a");
                if(next_new_page.length){
                  $('.infinite_next a').attr('href',next_new_page.attr('href'));
                  $('.load-more-wrap').show();
                } else {
                  $('.infinite_next,.load-more-wrap').remove();
                }
                
                $_order_loading_page = '';
                order_next_loading = false;
                $('.load-indicator').removeClass('loading');
                
              },
              dataType: "html"
          });
     }

    $('.load_more_orders').click(function(){
      if(order_next_loading == false)
        loadMoreOrders();
      return false;
    });
    
     
  }


  
  function responsiveUpdates(){
    setTimeout(function(){

      var grid_items = $('.grid-masonary .ref-grid-item');
      if(grid_items.length){
        var h = 0;
        grid_items.height('auto');
        grid_items.each(function(){
          if($(this).height()>h) h = $(this).height();
        });
        grid_items.height(h);
        
      }
      
      var grid_h = $('.grid__item.double-horizontal,.grid__item.single,.grid__item.double');
      if(grid_h.length){
        grid_h.each(function(){
          var me = $(this);
          var ref_e = me.next();
          if(ref_e.length == 0) 
            var ref_e = me.previous();
          if(ref_e.length) me.height( ref_e.height() )
        });
      }

      var grid_dz = $('.grid__item.double-size');
      if(grid_dz.length){
        var item_mb = 10;
        var windowWidth = $(window).width();
        if (windowWidth >= 990) {
          item_mb = 20;
        } else if (windowWidth >= 750) {
          item_mb = 14;
        }
        
        grid_dz.each(function(){
          var me = $(this);
          var ref_e = me.next();
          if(ref_e.length == 0) 
            var ref_e = me.previous();
          me.height('auto');
          if(ref_e.length) 
            me.height( (ref_e.height() * 2) + item_mb )
        });
        
      }
      if($(window).width()<750){ 
        $('.grid__item.double,.grid__item.double-size').height('auto');
      }

      if($('.grid-masonary').length){
        var set_gutter = false;
        if($(window).width() >= 990 && (mobile_gutter_set == true || tablet_gutter_set == true )){
          set_gutter = true;
        } else if($(window).width() >= 750 && $(window).width() < 990 && (desktop_gutter_set == true  || mobile_gutter_set == true) ){
          set_gutter = true;
        } else if($(window).width() < 750 && (desktop_gutter_set == true  || tablet_gutter_set == true ) ){
          set_gutter = true;
        }

        
        if(set_gutter){
          setTimeout(function(){
            $grid_masonary.isotope({
              itemSelector: '.grid__item',
              percentPosition: true,
              masonry: {
                columnWidth: '.ref-grid-item',
                gutter: getGutterSize()
              }
            });
            $grid_masonary.isotope('layout');
          },300);
        } else {
          $grid_masonary.isotope('layout');
        }
      }

      if($(window).width() >= 575){
        $('ul.navigation-grid ul').show();
      }
      
   },300);
  }
  responsiveUpdates();
  $(window).on("load resize",function(e){
    responsiveUpdates();
  });


  $(document).on("change",".gift-wrap-selection",function(e) {
    updateLuxeWrapInCart($(this));
  });
    $(window).on('load', function () {
      setSelectedGiftWrap();
    });

    //$('.cart-items').on('DOMSubtreeModified', function(){
    //  setSelectedGiftWrap();
    //});

  var os_iframe = $('.order-status-wrap > iframe');
  if(os_iframe.length){
    $('.order-status-wrap > iframe').on('load', function () {
      $('.order-status-wrap > iframe').contents().find("head").append($('.os_styles').html());

      setTimeout(function(){
        $('.order-status-wrap').css({'opacity':'1'});
        
        var iframe = $('.order-status-wrap > iframe')[0];
        var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        var newIframeHeight = iframeDocument.body.scrollHeight + 30;
        iframe.style.height = newIframeHeight + 'px';
      },100)
      
    });
  }

  $('.link-klaviyo-popup .announcement-bar__link').click(function(){
    window._klOnsite = window._klOnsite || []; 
    window._klOnsite.push(['openForm', 'SGz3KP']);
    return false;
  });
  
});
